var _defs, _circle, _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPetFriendlyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6c6c6c;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 126.11,
    cy: 102.28,
    r: 2.68
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173.19,102.28c-7.25-3.88-21.42-8.72-29.37-21.85s-27.64-13.14-39.39-8.64S83.35,89.24,80.58,102.28,74,119.47,67.45,127.08s-9.85,16.72-6,25A40.64,40.64,0,0,0,78.36,170.5s7.41,5,37.12,7.72S175.27,164.4,184.6,143,180.45,106.17,173.19,102.28Zm-47.43,45.36a1.47,1.47,0,1,1,1.47-1.47A1.46,1.46,0,0,1,125.76,147.64Zm14.49-7a42.3,42.3,0,0,1,7.49,29.6,49.14,49.14,0,0,1-18.66,5.19c1.84-7-1.39-16.13-1.39-16.13,10.37-.46,9.57-9.68,9.57-9.68s-4.15-.34-4.84-2.41a14.21,14.21,0,0,0-2.54-5.53c-2.19-3.34-6.79-3-6.79-3l-.81-5.41c-7.26,1.38-9.68,2.88-11.63,12.9s-2.88,16.47-8.64,21.31-14.17,3.34-14.17,3.34,7.6-10.6,11.06-21.2S101.09,127,101.09,127s8.06,2.77,9.79,3.11,1.38-2,2.74-7.25-1.59-9-3.66-12.91-1.16-9.67-1.16-9.67c-7.14,8.52,1.73,15.32,2,18.66s-1.84,7-3.22,7.14-12.79-4.26-15-5.87-3.22-3.11-2.53-6,8.29-18.66,21.42-22.58,16.24,1.61,23.85,3.45,15-1.15,15-1.15c4.84,9.56-4.26,16-10.6,21.54S130,126.16,140.25,140.67Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 48.45,
    cy: 87.81,
    rx: 17.1,
    ry: 23.02,
    transform: "translate(-35.03 32.23) rotate(-27.46)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 179.35,
    cy: 68.33,
    rx: 23.02,
    ry: 17.1,
    transform: "translate(60.14 218.74) rotate(-72.46)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 137.82,
    cy: 34.87,
    rx: 27.27,
    ry: 20.26,
    transform: "translate(63.03 155.77) rotate(-72.46)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 78.36,
    cy: 43.2,
    rx: 20.26,
    ry: 27.27,
    transform: "translate(-9.38 25.63) rotate(-17.54)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.5,190.73a9.14,9.14,0,0,1,6.65,1.68,7.73,7.73,0,0,1,3,5.67,7.63,7.63,0,0,1-1.94,6.15,9.52,9.52,0,0,1-6.39,2.89l-5.25.5,1.12,11.83-5.45.51-2.67-28.2ZM111.3,203a5.27,5.27,0,0,0,3.3-1.32,3.61,3.61,0,0,0,.94-3.08q-.36-3.88-5.37-3.42l-3.72.35.75,7.86Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143,187.75l.41,4.26-12.78,1.21.7,7.41,12.23-1.16.41,4.26-12.24,1.16.76,8,13.06-1.24.41,4.26-18.51,1.75-2.68-28.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.74,185l.4,4.26-10,.95,2.27,23.94-5.45.52-2.27-23.95-10,.95-.41-4.26Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.58,226.87l.2,2.14-5.9.56.35,3.65,5.9-.56.2,2.16-5.9.56.59,6.2-2.73.26-1.35-14.15Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.16,226.15a4.73,4.73,0,0,1,3.36.8,3.63,3.63,0,0,1,1.53,2.76,3.57,3.57,0,0,1-.42,2.16,4.24,4.24,0,0,1-1.72,1.59,4.12,4.12,0,0,1,1.3.87,13.07,13.07,0,0,1,1.51,2c1,1.63,1.78,2.75,2.26,3.36l-3,.29a16.13,16.13,0,0,1-1-1.41,35,35,0,0,0-2-2.88,4,4,0,0,0-1.16-1,2.11,2.11,0,0,0-1.2-.22l-1,.09.57,6-2.74.26-1.34-14.16Zm0,6.1a2.49,2.49,0,0,0,1.64-.7,1.87,1.87,0,0,0,.47-1.53,1.73,1.73,0,0,0-.75-1.39,2.75,2.75,0,0,0-1.77-.32l-1.71.16.38,3.94Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.23,225.1l1.34,14.16-2.73.26-1.35-14.16Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.56,223.93l.2,2.14-6.41.61.35,3.72,6.14-.58L133,232l-6.14.59.39,4,6.55-.62.2,2.14-9.29.88-1.34-14.16Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.66,223.45l9.34,9.08-.93-9.88,2.67-.25,1.34,14.16-2.35.22-9.41-9.24,1,10-2.67.25-1.34-14.15Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.78,221.54a8.56,8.56,0,0,1,4,.53,6.7,6.7,0,0,1,2.91,2.28,7.17,7.17,0,0,1,1.3,3.58,7,7,0,0,1-.61,3.77,6.37,6.37,0,0,1-2.48,2.75,8.9,8.9,0,0,1-4,1.26l-5.77.55-1.34-14.15Zm.85,12.05a4.94,4.94,0,0,0,3.52-1.71,5.42,5.42,0,0,0-.69-7.19,5.2,5.2,0,0,0-3.85-1l-2.82.26.94,9.88Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.63,220.33l1.14,12,6.87-.65.2,2.14-9.61.91-1.34-14.15Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.35,219.5l3.87,4.41,3-5.06,3.25-.31-4.67,7.65.66,7-2.73.26-.67-7L176,219.82Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetFriendlyIcon);
export default __webpack_public_path__ + "static/media/pet-friendly-icon.dcd9033b28dc5bc19f24bbcfd78c8881.svg";
export { ForwardRef as ReactComponent };